import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const Signup = () => {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await signup(email, password, name || null);
      toast.success("You're in. The First 72 Hours is already in your library.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-in min-h-[80vh] flex items-center justify-center px-6">
      <form onSubmit={submit} className="card-surface p-10 w-full max-w-md" data-testid="signup-form">
        <div className="text-xs uppercase tracking-[0.24em] text-teal-300/80 mb-4">Begin</div>
        <h1 className="font-display text-4xl mb-2">Create your space</h1>
        <p className="text-sm text-neutral-400 mb-8">
          Save your reframes, missions, and streak. Get "The First 72 Hours" free.
        </p>
        <label className="block mb-4">
          <span className="text-xs text-neutral-400 uppercase tracking-wider">Name (optional)</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="signup-name-input"
            className="wwr-input w-full rounded-xl px-4 py-3 mt-1 text-sm"
          />
        </label>
        <label className="block mb-4">
          <span className="text-xs text-neutral-400 uppercase tracking-wider">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="signup-email-input"
            className="wwr-input w-full rounded-xl px-4 py-3 mt-1 text-sm"
          />
        </label>
        <label className="block mb-6">
          <span className="text-xs text-neutral-400 uppercase tracking-wider">Password</span>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="signup-password-input"
            className="wwr-input w-full rounded-xl px-4 py-3 mt-1 text-sm"
          />
        </label>
        <button
          type="submit"
          disabled={loading}
          data-testid="signup-submit-btn"
          className="btn-primary w-full py-3 disabled:opacity-60"
        >
          {loading ? "Creating…" : "Create account"}
        </button>
        <p className="text-sm text-neutral-400 mt-6 text-center">
          Already have one?{" "}
          <Link to="/login" data-testid="signup-login-link" className="text-teal-300 hover:text-teal-200">
            Log in
          </Link>
        </p>
      </form>
    </div>
  );
};

export default Signup;
